import { ActionContext } from 'vuex'

import { RootState } from '../types'
import rest from '@/rest'
import { LocaleMap } from '@/types/i18n'

interface I18nState {
  allLocales: LocaleMap
  loading: boolean
  englishCountries: Record<string, string>
}

type I18nActionContext = ActionContext<I18nState, RootState >

const state: I18nState = {
  allLocales: {},
  loading: false,
  englishCountries: {}
}

const mutations = {
  SET_LOADING (state: I18nState, loading: boolean) {
    state.loading = loading
  },
  SET_LOCALES (state: I18nState, data: LocaleMap) {
    state.allLocales = data
  },
  SET_ENGLISH_COUNTRIES (state: I18nState, data: Record<string, string>) {
    state.englishCountries = data
  }

}

const actions = {
  async LOAD_LOCALES (ctx: I18nActionContext) {
    ctx.commit('SET_LOADING', true)
    try {
      const locales = await rest.i18n.getAllLocales()
      const countries = await rest.i18n.getAllCountries()
      ctx.commit('SET_LOCALES', locales)
      ctx.commit('SET_ENGLISH_COUNTRIES', countries.en)
    } finally {
      ctx.commit('SET_LOADING', false)
    }
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  getters: {
    allLocales: (state: I18nState) => state.allLocales,
    englishCountries: (state: I18nState) => state.englishCountries
  },
  actions
}
